module.exports = __webpack_public_path__ + "static/media/writingjapaneseanimal_title_audio.53eafe8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wja/audio/writingjapaneseanimal_title_audio.mp3
// module id = Dd4l
// module chunks = 0